import styled from 'styled-components';
export var StyledCollapsible = styled.div.withConfig({
  displayName: "Collapsiblestyles__StyledCollapsible",
  componentId: "sc-1k807m8-0"
})([""]);